// extracted by mini-css-extract-plugin
export default {"box":"Variations_box__evMwD"};